import ReCAPTCHA from "react-google-recaptcha"

import React from "react"
import { Field, useField } from "formik"
import { FormContext } from "../Form"
import cx from "classnames"

const ReCAPTCHA2 = () => {
  const [value, meta, helpers] = useField("recaptcha")
  //const [meta, helpers] = useField("recaptcha")
  const recaptchaRef = React.createRef();
  const error = meta.touched && meta.error

  return <FormContext.Consumer>
    {/* {({ negative, big }) => { */}
    {() => {
      return <Field name={"recaptcha"} validate={(value) => {
        return value ? false : "recaptcha is not valid"
      }}>
        {/* {({ field, meta }) => { */}
        {() => {
          return <div className={cx("recaptcha-wrapper", { "error": error })}>
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LeugBYqAAAAAKwHMGsF400c_XouvktsRTTLhbNM"
              onChange={(token) => {
                helpers.setValue(token && token !== "")
              }}
            />
          </div>
        }}
      </Field>
    }}
  </FormContext.Consumer >
}

export default ReCAPTCHA2
